module.exports = __webpack_public_path__ + "img/cross-blk.87dd3042.svg";